import React from "react";
import "./Download.css";
import downloadimg from "./download.png";
import { Link } from "react-router-dom";

const Download = () => {
  return (
    <div className="main-container-down">
      <div className="down-one">
        <h2>Download</h2>
      </div>
      <hr />

      <div className="down-body">
        <div className="down-two">
          <p className="downp">
            <span>Office</span>
          </p>
          <div className="down-img">
            <img src={downloadimg} />
          </div>
        </div>

        <div className="down-three">
          <p className="downp">
            <span>Company Catalogues & Brochures</span>
          </p>
          <div className="list">
            <Link to="#">
              <li className="down-li">
                SWAJIT - Cement, Power,Palm Oil, Chemical & fertilizer : Click
                to download
              </li>
            </Link>
            <Link to="#">
              <li className="down-li">
                SWAJIT - Sugar Industry Conveyor Catalogue : Click to download
              </li>
            </Link>
            <Link to="#">
              <li className="down-li">
                SWAJIT - Maintenance Manual : Click to download
              </li>
            </Link>
            <Link to="#">
              <li className="down-li">
                SWAJIT - Sprocket, Bucket and Pan Catalogue : Click to download
              </li>
            </Link>
            <Link to="#">
              <li className="down-li">
                SWAJIT - Transmission Chain Brochuer : Click to download
              </li>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
